import React from 'react';
import { ApIcon, ApButtonSecondary } from '@alixpartners/ui-components';
import {
	Wrapper,
	StepCircle,
	StepWrapper,
	StepTitle,
	Conector,
	Title,
	ButtonWrapper,
} from './StepHeader.styles';

export const StepHeader = ({ activeStep, options, onStepClick, isEdit }) => {
	const activeStepIndex = options.findIndex(item => item.step === activeStep);

	return (
		<Wrapper>
			{!isEdit ? (
				options.map(({ label, step }, index) => {
					const isStepActive = index <= activeStepIndex;

					return (
						<React.Fragment key={step}>
							<StepWrapper
								className={isStepActive && 'active'}
								onClick={isStepActive ? () => onStepClick(step) : undefined}
							>
								<StepCircle>
									{index >= activeStepIndex ? (
										index + 1
									) : (
										<ApIcon iconName="check" iconColor="white" iconSize={16} />
									)}
								</StepCircle>
								<StepTitle>{label}</StepTitle>
							</StepWrapper>
							{index < options.length - 1 && <Conector />}
						</React.Fragment>
					);
				})
			) : (
				<React.Fragment>
					<Title>Edit initiative</Title>
					{activeStep === 3 && (
						<ButtonWrapper>
							<ApButtonSecondary
								iconName="baseline_add"
								onClick={() => {
									onStepClick(2);
								}}
							>
								Add / remove items
							</ApButtonSecondary>
						</ButtonWrapper>
					)}
				</React.Fragment>
			)}
		</Wrapper>
	);
};

export default StepHeader;
